<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" scrollable persistent :width="size">
      <v-card>
        <v-card-title class="headline">
          {{ title }}
          <button class="close-modal" type="button" @click="fechar">
            <i class="icon close"></i>
          </button>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <div style="height: 50vh">
            <iframe
              :src="url"
              frame=""
              style="width: 100%; height: 100vh; border: 0;"
            >
            </iframe>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>

export default {
  name: 'ModalIframe',
  props: ['title', 'dialog', 'url', 'size'],
  data() {
    return {
      showIframe: this.dialog,
    };
  },
  methods: {
    fechar() {
      this.showIframe = false;
      this.$emit('close', false);
    },
  },
};
</script>
<style lang="scss">
  .close-modal {
    position: absolute;
    right: 15px;
  }
  .v-dialog {
    overflow: hidden;

    .table-scroll {
      overflow-y: auto;
      height: 90vh;
    }
  }
</style>
